(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var surfers = [];

    function clamp(value, min, max) {
      return Math.min(max, Math.max(min, value));
    }

    function setup(root) {
      var track = root.querySelector('.collection-surfer__track');
      var viewport = root.querySelector('.collection-surfer__viewport');
      var world = root.querySelector('.collection-surfer__world');
      var cards = root.querySelectorAll('[data-surfer-card]');
      var itemCount = parseInt(root.getAttribute('data-item-count'), 10) || 0;
      if (!track || !viewport || !world || itemCount < 1) return null;

      return {
        root: root,
        track: track,
        viewport: viewport,
        world: world,
        cards: cards,
        itemCount: itemCount,
        mouseX: -10000,
        mouseY: -10000,
        progress: 0
      };
    }

    function steps() {
      if (window.innerWidth < 750) {
        return { x: 160, y: -56, z: -180 };
      }
      return { x: 240, y: -84, z: -288 };
    }

    function apply(surfer) {
      var s = steps();
      var looped = surfer.progress % 1;
      var shift = looped * surfer.itemCount;
      surfer.world.style.transform =
        'translate3d(' +
        -shift * s.x +
        'px,' +
        -shift * s.y +
        'px,' +
        -shift * s.z +
        'px)';

      surfer.cards.forEach(function (card, index) {
        var baseX = index * s.x;
        var baseY = index * s.y;
        var baseZ = index * s.z;
        var scale = 1;

        if (!reduced) {
          var rect = card.getBoundingClientRect();
          var cx = rect.left + rect.width / 2;
          var cy = rect.top + rect.height / 2;
          var dist = Math.sqrt(Math.pow(surfer.mouseX - cx, 2) + Math.pow(surfer.mouseY - cy, 2));
          var closeness = clamp(1 - dist / 400, 0, 1);
          scale = 1 + closeness * 0.5;
          if (closeness > 0.15) {
            card.classList.add('is-hot');
          } else {
            card.classList.remove('is-hot');
          }
        }

        card.style.transform =
          'translate3d(' +
          baseX +
          'px,' +
          baseY +
          'px,' +
          baseZ +
          'px) rotateY(-50deg) scale(' +
          scale +
          ')';
      });
    }

    function update() {
      surfers.forEach(function (surfer) {
        if (reduced) {
          surfer.progress = 0;
          apply(surfer);
          return;
        }
        var rect = surfer.track.getBoundingClientRect();
        var total = surfer.track.offsetHeight - window.innerHeight;
        var target = total > 0 ? clamp(-rect.top / total, 0, 1) : 0;
        surfer.progress = surfer.progress + (target - surfer.progress) * 0.12;
        apply(surfer);
      });
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        update();
        ticking = false;
      });
    }

    function bind(surfer) {
      surfer.viewport.addEventListener('mousemove', function (event) {
        surfer.mouseX = event.clientX;
        surfer.mouseY = event.clientY;
        apply(surfer);
      });
      surfer.viewport.addEventListener('mouseleave', function () {
        surfer.mouseX = -10000;
        surfer.mouseY = -10000;
        apply(surfer);
      });
    }

    function collect() {
      surfers = [];
      document.querySelectorAll('[data-collection-surfer]').forEach(function (root) {
        var surfer = setup(root);
        if (!surfer) return;
        bind(surfer);
        surfers.push(surfer);
      });
      update();
    }

    collect();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    document.addEventListener('shopify:section:load', collect);
    document.addEventListener('shopify:section:unload', collect);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallax-unfurling-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var galleries = [];
    var ticking = false;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function lerp(start, end, progress) {
      return start + (end - start) * progress;
    }

    function clamp(value, min, max) {
      return Math.min(max, Math.max(min, value));
    }

    function mapRange(value, inMin, inMax, outMin, outMax) {
      var progress = clamp((value - inMin) / (inMax - inMin), 0, 1);
      return lerp(outMin, outMax, progress);
    }

    function setupGallery(root) {
      var track = root.querySelector('.parallax-gallery__track');
      var banner = root.querySelector('.parallax-gallery__banner');
      var matrix = root.querySelector('.parallax-gallery__matrix');
      var columns = root.querySelectorAll('[data-parallax-column]');
      if (!track || !banner || !matrix) return null;

      return {
        root: root,
        track: track,
        banner: banner,
        matrix: matrix,
        columns: columns,
        progress: reducedMotion ? 1 : 0
      };
    }

    function applyTransforms(gallery) {
      var progress = gallery.progress;
      var bannerProgress = mapRange(progress, 0, 0.15, 0, 1);
      var unfurlProgress = mapRange(progress, 0.15, 1, 0, 1);

      gallery.banner.style.width = lerp(90, 100, bannerProgress) + 'vw';
      gallery.banner.style.height = lerp(80, 100, bannerProgress) + 'vh';
      gallery.banner.style.borderRadius = lerp(48, 0, bannerProgress) + 'px';

      var rotateX = lerp(25, 4, unfurlProgress);
      var rotateY = lerp(-45, -8, unfurlProgress);
      var rotateZ = lerp(15, 2, unfurlProgress);
      var translateZ = lerp(-800, 0, unfurlProgress);

      gallery.matrix.style.transform =
        'translateZ(' + translateZ + 'px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg) rotateZ(' + rotateZ + 'deg)';

      var columnStarts = [0, -40, 0, -30];
      var columnEnds = [-40, 10, -40, 20];
      gallery.columns.forEach(function (column, index) {
        var y = lerp(columnStarts[index], columnEnds[index], unfurlProgress);
        column.style.transform = 'translateY(' + y + '%)';
      });
    }

    function updateGalleries() {
      galleries.forEach(function (gallery) {
        if (reducedMotion) {
          gallery.progress = 1;
          applyTransforms(gallery);
          return;
        }

        var rect = gallery.track.getBoundingClientRect();
        var total = gallery.track.offsetHeight - window.innerHeight;
        var target = total > 0 ? clamp(-rect.top / total, 0, 1) : 0;
        gallery.progress = gallery.progress + (target - gallery.progress) * 0.12;
        applyTransforms(gallery);
      });
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        updateGalleries();
        ticking = false;
      });
    }

    function collectGalleries() {
      galleries = [];
      document.querySelectorAll('[data-parallax-gallery]').forEach(function (root) {
        var gallery = setupGallery(root);
        if (gallery) galleries.push(gallery);
      });
      updateGalleries();
    }

    collectGalleries();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    document.addEventListener('shopify:section:load', collectGalleries);
    document.addEventListener('shopify:section:unload', collectGalleries);
  })();

  } catch(e) { console.error(e); }
})();
})();
